import { createAssetFactory } from '@exodus/ethereum-api'
import assetsList from '@exodus/ethereumarbone-meta'

const createAsset = createAssetFactory({
  assetsList,
  feeDataConfig: {
    gasPrice: '1.25 Gwei',
    max: '25 Gwei',
    min: '0.1 Gwei',
    fuelThreshold: '25 Gwei',
    eip1559Enabled: false,
    gasPriceMultiplier: 1.5,
  },
  erc20FuelBuffer: 1.1, // 10% more than the required fee
  serverUrl: 'https://arbitrum-one-clarity.a.exodus.io',
  confirmationsNumber: 3,
  monitorType: 'clarity-v2',
  forceGasLimitEstimation: true,
})

const assetPlugin = { createAsset }

export default assetPlugin
